import analyzeChartExportService from "src/services/chart-export";
import { withFulFilled, withPending, withRejected } from "../reducers/commons";
import { EVOLUTIVE_CROSS_CARD } from "src/sections/GroupCards/cardTypes";

// ACTIONS
export const GET_EXPORTED_CHART_PAYLOAD = "GET_EXPORTED_CHART_PAYLOAD";
export const CLEAR_EXPORTED_CHART_PAYLOAD = "CLEAR_EXPORTED_CHART_PAYLOAD";

const PNG = "png";
const CSV = "csv";
const XLSX = "xlsx";

/**
 *
 * @param {string} exportingType png | csv | xlsx
 * @param {object} exportOptions Objeto de configuração da exportação, caso seja png, terá o modelo
 * de exportação do gráfico, caso seja csv ou png, terá as informações necessárias para realizar
 * a exportação em csv ou xlsx.
 */
export function updateExportedChartPayload(
  exportingType,
  exportOptions,
  dispatch
) {
  if (exportingType === PNG) {
    dispatch({ type: GET_EXPORTED_CHART_PAYLOAD, payload: exportOptions });
  } else if ([CSV, XLSX].includes(exportingType)) {
    const { cardType, surveyId, customerId, analyzeId, idPerguntaCruzada, idAlternativaCruzada } = exportOptions;
    
    const defaultMetodosExportacao = {
      [CSV]: analyzeChartExportService.getCSV,
      [XLSX]: analyzeChartExportService.getXLSX
    };

    const metodosExportacaoEvolutivoCruzamentos = {
      [CSV]: analyzeChartExportService.getCSVEvolutivoCruzamentos,
      [XLSX]: analyzeChartExportService.getXLSXEvolutivoCruzamentos
    };

    const defaultArgs = [
      cardType,
      surveyId,
      analyzeId,
      customerId,
    ];

    let args = [...defaultArgs];

    let metodoExportacao;

    if (cardType !== EVOLUTIVE_CROSS_CARD) {
      metodoExportacao = defaultMetodosExportacao[exportingType];
    } else {
      args.length = 0;
      args.push(analyzeId, idPerguntaCruzada, idAlternativaCruzada);

      metodoExportacao = metodosExportacaoEvolutivoCruzamentos[exportingType];
    }

    const result = metodoExportacao(...args);

    // Pending state
    dispatch({ type: withPending(GET_EXPORTED_CHART_PAYLOAD) });
    // Fulfilled state
    result
      .then(({ data }) => {
        dispatch({
          type: withFulFilled(GET_EXPORTED_CHART_PAYLOAD),
          payload: data,
        });
      })
      // Rejected state
      .catch((error) => {
        dispatch({
          type: withRejected(GET_EXPORTED_CHART_PAYLOAD),
          payload: error,
        });
      });
  }
}

export function clearExportedChartPayload(dispatch) {
  dispatch({ type: CLEAR_EXPORTED_CHART_PAYLOAD });
}
